import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

const initialState = {
  opened: false,
  products: [],
  searchList: []
};

let store = (set, get) => ({
  ...initialState,
  updateProducts: products => {
    set(() => ({
      products
    }));
  },
  addSearch: searchTerm => {
    const searchList = get().searchList;
    const isAlreadyAdded = searchList.findIndex(item => item === searchTerm) >= 0;
    if (isAlreadyAdded) return;
    searchList.unshift(searchTerm);
    set(() => ({
      searchList
    }));
  },
  removeSearch: searchTerm => {
    const searchList = get().searchList;
    const index = searchList.findIndex(item => item === searchTerm);
    if (index < 0) return;
    searchList.splice(index, 1);
    set(() => ({
      searchList
    }));
  },
  resetSearchList: () => {
    set(() => ({
      searchList: []
    }));
  },
  setOpened: opened => {
    set(() => ({
      opened
    }));
  },
  reset: () => set(initialState)
});

store = persist(store, {
  name: 'shoppingCart',
  storage: createJSONStorage(() => sessionStorage)
});
export const useShoppingCart = create(devtools(store));
